import { useConversation } from "@elevenlabs/react";
export default function VoiceAssistant() {

  const conversation = useConversation({
    agentId: "agent_9301k72x0w3fe7rtj2db242hgnds"
  });

  const startConversation = async () => {
    await conversation.startSession();
  };

  const endConversation = async () => {
    await conversation.endSession();
  };

  return (
    <div>
<div
  style={{
    position: "fixed",
    bottom: "20px",
    right: "20px",
    width: "220px",
    background: "#fff",
    borderRadius: "15px",
    boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
    padding: "15px",
    textAlign: "center"
  }}
>
  <img
  src="/vishruthi.png"
  alt="vishruthi"
  width="200"
  height="100"
/>
  <h4 style={{ margin: "5px 0" }}>Vishruthi AI</h4>
  <p style={{ fontSize: "12px", color: "#666" }}>
    Your Internship Assistant
  </p>

  <button
    onClick={startConversation}
    style={{
      width: "100%",
      marginTop: "10px",
      padding: "8px",
      borderRadius: "8px",
      backgroundColor: "green",
      color: "white",
      border: "none",
      cursor: "pointer"
    }}
  >
    🎤 Talk to Vishruthi
  </button>

  <button
    onClick={endConversation}
    style={{
      width: "100%",
      marginTop: "8px",
      padding: "8px",
      borderRadius: "8px",
      backgroundColor: "red",
      color: "white",
      border: "none",
      cursor: "pointer"
    }}
  >
    End Conversation
  </button>
</div>
    </div>
  );
}